import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';

interface ApiResponse {
  message: string;
  add: string;
  fail: string;
}

@Injectable({
  providedIn: 'root'
})
export class StudentService {

  constructor(private http: HttpClient) { }

  // GetStudentList(where) {
  //   return this.http.get(environment.apiUrl+"Student/" + "GetStudentList?whr="  + where )
  // }
  GetStudentList(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  InsertStudent(data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertStudent', data);
  }

  GetStudentDetail(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentDetail/' + studentid);
  }
  UpdateStudent(studentid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateStudent/' + studentid, data);
  }
  GetStudentAttendnaceList(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendnaceList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendance(searchdate, date, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendance?attdate=' + btoa(searchdate).replace(/=+$/, '') + '&date=' + btoa(date).replace(/=+$/, '') + '&whr=' + btoa(where).replace(/=+$/, ''));
  }
  AddStudentAttendance(dsbatch: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddStudentAttendance/' + dsbatch + '/' + userid, data);
  }
  GetStudentAttendanceDetail(attdate, debatch, createby, role) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceDetail?attdate=' + attdate + '&batchid=' + debatch + '&createby=' + createby + '&userole=' + role);

  }
  UpdateStudentAttendance(debatch: string, createby: string, attid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateStudentAttendance/' + debatch + '/' + createby + '/' + attid, data);
  }
  GetStudentCourse(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentCourse?whr=' + btoa(where).replace(/=+$/, ''));
  }
  AddStudentCourse(data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddStudentCourse/', data);
  }
  UpdateStudentCourse(studentid: string, studcourseid: string, data) {

    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateStudentCourse/' + studentid + '/' + studcourseid, data);
  }
  UpdateStudentIDI(studentid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateStudentIDI/' + studentid, data);
  }
  InsertIDIStudent(data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIDIStudent', data);
  }
  GetStudentIDIList(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentIDIList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentIDIDetail(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentIDIDetail/' + studentid);
  }
  InsertIDIStudentQualification(studentid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIDIStudentQualification/' + studentid, data);
  }

  GetIDIStudentQualification(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDIStudentQualification/' + studentid);
  }
  RemoveIDIStudentQualification(quliid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'RemoveIDIStudentQualification/' + quliid);
  }

  InsertIDIStudentLanguage(studentid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIDIStudentLanguage/' + studentid, data);
  }

  GetIDIStudentLanguage(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDIStudentLanguage/' + studentid);
  }

  RemoveIDIStudentLnaguage(stlangid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'RemoveIDIStudentLnaguage/' + stlangid);
  }

  AddStudentFamily(userid, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddStudentFamily?userid=' + userid, data);
  }

  GetStudentFamilyDetail(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentFamilyDetail/' + studentid);
  }


  GetStudentCourseDetail(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentCourseDetail/' + studentid);
  }

  RemoveStudentCourse(studcourseid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'RemoveStudentCourse/' + studcourseid);
  }

  AddStudentFee(userid, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddStudentFee?userid=' + userid, data);
  }

  GetStudentFeesDetail(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentFeesDetail/' + studentid);
  }

  RemoveStudentFees(studcourseid: string, studfeeid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'RemoveStudentFees/' + studcourseid + '?studfeeid=' + studfeeid);
  }

  GetStudentIDIReport(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentIDIReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetStandardBatch(pgid: string, schoolid: string, std: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStandardBatch/' + pgid + '/' + schoolid + '/' + std);
  }

  GetStudentCALReport(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentCALReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  AddCandidates(userid: string, data) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddCandidates/' + userid, data);
  }
  AddLiteCandidates(userid: string, data) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddLiteCandidates/' + userid, data);
  }

  GetInterestedStudentYes(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetInterestedStudentYes/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetIntrestedIDIStudentLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIntrestedIDIStudentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetPendingJobSeeker(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPendingJobSeeker?whr=' + btoa(where).replace(/=+$/, ''));
  }

  FillDropDown1(tablename, column1, column2, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'FillDropDown1?tablename=' + tablename + '&column1=' + column1 + '&column2=' + column2 + '&whr=' + btoa(where).replace(/=+$/, ''));
  }

  UpdateCandidatesPending(userid: string, data) {

    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateCandidatesPending/' + userid, data);
  }

  GetRptStudentAttendanceBatchwise(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentAttendanceBatchwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetRptStudentAttendance(userid: string, role: string, pgid: string, whr: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetUploadStudentDetail(schoolid: string, createby: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUploadStudentDetail/' + schoolid + '/' + createby);
  }
  UpdateUploadStudentDetailNew(schoolid: string, createby: string, data: any) {
    return this.http.post<ApiResponse>(environment.apiUrl + 'Student/' + 'UpdateUploadStudentDetailNew/' + schoolid + '/' + createby, data);
  }
  UploadStudent(schoolid: string, academicyear: string, userid: string, data: any) {

    return this.http.post(environment.apiUrl + 'Student/' + 'UploadStudent/' + schoolid + '/' + academicyear + '/' + userid, data);
  }

  GetStudentReportATAL(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentReportATAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentReportUBS(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentReportUBS/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }



  GetStudentListATAL(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentListATAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetStudentListUBS(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentListUBS/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptCALWeeklyAttedance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALWeeklyAttedance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptATALWeeklyAttedance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptATALWeeklyAttedance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIDIStudentAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIStudentAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptCALStudentAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALStudentAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALSchoolAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALSchoolAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  IDIStudentEnrollentReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'IDIStudentEnrollentReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetStudentsForExport(schoolid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentsForExport/' + schoolid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadStudentIdiLite(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadStudentIdiLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  UpdateUploadStudentCAL(updateby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateUploadStudentCAL/' + updateby, data);
  }

  UpdateUploadStudentIdiLite(centid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateUploadStudentIdiLite/' + centid + '/' + createby, data);
  }


  UploadUpdateStudent(schoolid: string, userid: string, data: any) {

    return this.http.post(environment.apiUrl + 'Student/' + 'UploadUpdateStudent/' + schoolid + '/' + userid, data);
  }


  GetUploadUpdateStudentDetail(schoolid: string, createby: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUploadUpdateStudentDetail/' + schoolid + '/' + createby);
  }

  GetRptMonthwiseEnrollmentCAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMonthwiseEnrollmentCAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptCALSchoolWeekAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALSchoolWeekAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptAssessmentUsers(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAssessmentUsers/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALAssessmentNotification(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALAssessmentNotification/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALAssessmentAINotification(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALAssessmentAINotification/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessment(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessment/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetIDIAssessmentNotification(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDIAssessmentNotification/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptGenderwiseEnrollment(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptGenderwiseEnrollment/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  MonthlyStudentDataCount(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMonthlyStudentDataCount/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetCALSchoolAssessment(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALSchoolAssessment/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment1(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment2(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment3(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment3/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment4(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment4/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment5(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment6(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment7(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment8(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment9(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment10(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment11(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessment12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessment12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  // ATAL Monthwiseenrolment summary

  GetRptMonthwiseEnrollmentATAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMonthwiseEnrollmentATAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }



  // ATAL GradewiseAttendannce Report
  GetRptATALStudentAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptATALStudentAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptATALSchoolAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptATALSchoolAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptCALAssessmentATAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentATAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment6(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment7(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment8(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment9(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment10(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment11(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessment12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessment12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSchoolAssessmentATAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolAssessmentATAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  // ATAL Participant

  GetTechnovatorsParticipantsList(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTechnovatorsParticipantsList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetRptTechnovatorsParticipants(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptTechnovatorsParticipants/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetTechnovatorsParticipantsDetail(regid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTechnovatorsParticipantsDetail/' + regid);
  }

  InsertATALParticipation(data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertATALParticipation', data);
  }
  GetATALParticipationDetail(regid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALParticipationDetail/' + regid);
  }
  GetATALParticipationotherDetail(regid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALParticipationotherDetail/' + regid);
  }
  AddATALParticipationDetail(rgid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddATALParticipationDetail/' + rgid, data);
  }
  GetRptATALParticipationPendingStudent(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptATALParticipationPendingStudent/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetCALDashSchoolList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALDashSchoolList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALDashAllSchoolList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALDashAllSchoolList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  // ATAL Student
  UploadATALStudent(schoolid: string, academicyear: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UploadATALStudent/' + schoolid + '/' + academicyear + '/' + userid, data);
  }

  GetUploadATALStudentDetail(schoolid: string, createby: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUploadATALStudentDetail/' + schoolid + '/' + createby);
  }

  UpdateUploadATALStudentDetail(createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateUploadATALStudentDetail/' + createby, data);
  }

  UpdateUploadStudentATAL(updateby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateUploadStudentATAL/' + updateby, data);
  }

  UploadUpdateStudentATAL(schoolid: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UploadUpdateStudentATAL/' + schoolid + '/' + userid, data);
  }

  GetUploadUpdateStudentDetailATAL(schoolid: string, updateby: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUploadUpdateStudentDetailATAL/' + schoolid + '/' + updateby);
  }
  GetCALCompAssessmentFinal10(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal11(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCyberSmartUsers(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCyberSmartUsers/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  // schoolwise Time Table

  GetTimeTableMasterList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTimeTableMasterList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolMasterTTList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolMasterTTList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  RemoveTimeTableMasterDetails(ttdid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'RemoveTimeTableMasterDetails/' + ttdid);
  }
  UpdateSchoolwiseTimeTableDetail(ttmid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateSchoolwiseTimeTableDetail?ttmid=' + ttmid + '&createby=' + createby, data);
  }

  GetTimeTableDetailsList(ttmid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTimeTableDetailsList/' + ttmid);
  }
  MyESchoolGetTimeTableDetailsList(ttmid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'MyESchoolGetTimeTableDetailsList/' + ttmid);
  }

  GetPlanTimeTableDetails(pmid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPlanTimeTableDetails/' + pmid);
  }
  GetMyESchoolPlanTimeTableDetails(pmid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyESchoolPlanTimeTableDetails/' + pmid);
  }
  GetschoolwisePlanTTList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetschoolwisePlanTTList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyESchoolwisePlanTTList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyESchoolwisePlanTTList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  AddIDIStudentAttendance(date: Date, batchid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddIDIStudentAttendance?date=' + date + '&batchid=' + batchid + '&createby=' + createby, data);
  }

  GetRptMonthlyStudentAttendanceIDI(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMonthlyStudentAttendanceIDI/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetStudentsForAttendance(schoolid: string, month: string, year: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentsForAttendance/' + schoolid + '/' + month + '/' + year);
  }

  GetRptCyberSmartPlanVsActualCount(whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCyberSmartPlanVsActualCount?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  // 3 remaning report 
  GetRptAttendanceSchoolWiseCAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCAL/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCALSancharak(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCALSancharak/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceCenterWiseCAL(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceCenterWiseCALSancharak(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCALSancharak/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCALSancharak(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCALSancharak/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCAL(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCALSancharak(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCALSancharak/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetCALCompAssessmentFinal5(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal6(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal7(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal8(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal9(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }


  // Competency wise Standard Final Reports
  GetATALCompAssessmentFinal6(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal6/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessmentFinal7(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal7/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  UploadStudentDOC(studentid: string, fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('Image', fileToUpload);
    return this.http.post(environment.apiUrl + 'Student/' + 'UploadStudentDOC/' + studentid, formData);
  }

  GetStudentDOC(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentDOC/' + studentid);
  }

  GetCALFinalAssessmentLevelwise(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALFinalAssessmentLevelwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetATALCompAssessmentFinal10(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessmentFinal11(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessmentFinal12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetATALCompAssessmentFinal8(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATALCompAssessmentFinal9(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALCompAssessmentFinal9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal1(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal1/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal2(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal2/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal3(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal3/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFinal4(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFinal4/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCompAssessmentFCBeginner1(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCompAssessmentFCBeginner1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCompAssessmentFCBeginner2(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCompAssessmentFCBeginner2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCompAssessmentFCBeginner3(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCompAssessmentFCBeginner3/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCompAssessmentFCBeginner4(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCompAssessmentFCBeginner4/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCompAssessmentFCBeginner5(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCompAssessmentFCBeginner5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptGenderwiseEnrollmentSancharak(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptGenderwiseEnrollmentSancharak/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptOverallBeneficiariesIDI(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptOverallBeneficiariesIDI/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }


  GetTimeTableMasterDetails(ttmid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTimeTableMasterDetails/' + ttmid);
  }
  GetMyEschoolMasterTTDetail(ttmid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolMasterTTDetail/' + ttmid);
  }
  GetMyEschoolMasterTTDetailLite(ttmid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolMasterTTDetailLite/' + ttmid);
  }
  GetCALCompAssessmentFCFinal6(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal7(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal8(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal9(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal10(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal11(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALCompAssessmentFCFinal12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddNewSchoolwiseTimeTableDetail(ttmid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddNewSchoolwiseTimeTableDetail?ttmid=' + ttmid + '&createby=' + createby, data);
  }
  GetRptIDIAgewiseStudentEnrollment(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIAgewiseStudentEnrollment/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetATLSchoolModuleData(academicyear: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATLSchoolModuleData/' + academicyear);
  }
  AddIDISocialMediaSubscription(createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddIDISocialMediaSubscription/' + createby, data);
  }
  GetStudentSocialMediaSubscription(whr: any) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentSocialMediaSubscription?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetIDIStudentSocialMediaDetail(batchid: string, createby: string, userole: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDIStudentSocialMediaDetail?batchid=' + batchid + '&createby=' + createby + '&userole=' + userole);
  }
  UpdateStudentSocialMedia(createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateStudentSocialMedia/' + createby, data);
  }
  GetSocialMediaSubscriptionList(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSocialMediaSubscriptionList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptSocialMediaSubscription(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSocialMediaSubscription/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }


  GetCALCompAssessmentEnglishFinal1(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentEnglishFinal1/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentEnglishFinal2(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentEnglishFinal2/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentEnglishFinal3(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentEnglishFinal3/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentEnglishFinal4(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentEnglishFinal4/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentMarathiFinal1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentMarathiFinal1/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentMarathiFinal2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentMarathiFinal2/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentMarathiFinal3(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentMarathiFinal3/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentMarathiFinal4(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentMarathiFinal4/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentHindiFinal1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentHindiFinal1/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentHindiFinal2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentHindiFinal2/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentHindiFinal3(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentHindiFinal3/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentHindiFinal4(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentHindiFinal4/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCompAssessmentFCBeginner6to12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCompAssessmentFCBeginner6to12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentFCFinal2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentFCFinal3(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal3/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentFCFinal4(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal4/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }


  GetCALCompAssessmentFCFinal5(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALCompAssessmentFCFinal1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALCompAssessmentFCFinal1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetStudentListMySchool(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentListMySchool/' + userid + '/' + role + '/' + pgid + '?whr=' + where);
  }


  //add api
  CheckStudentAttendanceCAL(schoolid: string, standard: string, batch: string, month: string, year: string, day: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'CheckStudentAttendanceCAL/' + schoolid + '/' + standard + '/' + batch + '/' + month + '/' + year + '/' + day);
  }

  // update api 
  AddActualStudentCAL(date: Date, standard: string, batchid: string, createby: string, strday: string, pgid: string, pdid: string, pmid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddActualStudentCAL?date=' + date + '&standard=' + standard + '&batchid=' + batchid + '&createby=' + createby + '&strday=' + strday + '&pgid=' + pgid + '&pdid=' + pdid + '&pmid=' + pmid, data);
  }
  GetStudentAssignmentDetailListCAL(schoolid: string, month: string, year: string, std: string, batchid: string, day: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttedanceDetailListCAL/' + schoolid + '/' + month + '/' + year + '/' + std + '/' + batchid + '/' + day);
  }

  InsertPlanTimeTableMasterNew(schoolid: string, centid: string, createby: string, month: string, year: string, timetableid: string, pgid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertPlanTimeTableMasterNew/' + schoolid + '/' + centid + '/' + createby + '/' + month + '/' + year + '/' + timetableid + '/' + pgid, data);
  }
  InsertMyESchoolPlanTimeTableMaster(schoolid: string, centid: string, createby: string, month: string, year: string, timetableid: string, pgid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertMyESchoolPlanTimeTableMaster/' + schoolid + '/' + centid + '/' + createby + '/' + month + '/' + year + '/' + timetableid + '/' + pgid, data);
  }

  InsertTimeTableMaster(schoolid: string, centid: string, createby: string, academicyear: string, ttno: string, pgid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertTimeTableMaster/' + schoolid + '/' + centid + '/' + createby + '/' + academicyear + '/' + ttno + '/' + pgid, data);
  }
  InsertMyESchoolTimeTableMaster(schoolid: string, centid: string, createby: string, academicyear: string, digiclass: string, pgid: string, mode: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertMyESchoolTimeTableMaster/' + schoolid + '/' + centid + '/' + createby + '/' + academicyear + '/' + digiclass + '/' + pgid + '/' + mode, data);
  }

  GetRptStudentMyschool(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentMyschool/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetCALAssessmentNotification1to4Lang(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALAssessmentNotification1to4Lang/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetCALAssessmentNotification1to4Math(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALAssessmentNotification1to4Math/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudAttendanceNotification(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudAttendanceNotification/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALSchoolAssessment1to4(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALSchoolAssessment1to4/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  CheckAdhaar(adharnumber: string) {
    console.log(adharnumber);

    return this.http.get(environment.apiUrl + 'Student/' + 'CheckAdhaar/' + adharnumber)
  }

  GetCALSchoolAssessment1to4Midline(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALSchoolAssessment1to4Midline/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetATALEndlineCompAssessment10(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALEndlineCompAssessment10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetATALEndlineCompAssessment12(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetATALEndlineCompAssessment12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetSchoolAssessmentATALEndline(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolAssessmentATALEndline/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetStudentCALReportSancharak(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentCALReportSancharak/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetRptATALSCHMonthlyStudentDataCount(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptATALSCHMonthlyStudentDataCount/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetSchoolAssessmentATAL2022(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolAssessmentATAL2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptCALAssessmentATAL2022(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentATAL2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptIDIStudentAttendance2022(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIStudentAttendance2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIDIStudentAttendance2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIStudentAttendance2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessment2022(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessment2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessment2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessment2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALSchoolAssessmentNew(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALSchoolAssessmentNew/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCAL2022(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCAL2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCALSancharak2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCALSancharak2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCAL2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCAL2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptStudentEgradeAtt(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentEgradeAtt/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCALSancharak2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCALSancharak2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCALNew(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCALNew/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCALSancharakNew(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCALSancharakNew/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceCenterWiseCALOLD(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCALOLD/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceCenterWiseCALSancharakOLD(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCALSancharakOLD/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptCALSchoolGradeWiseAssessment(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALSchoolGradeWiseAssessment/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlineAssessmentNotification(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlineAssessmentNotification/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAssessmentNotificationIDI(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAssessmentNotificationIDI/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALAssessmentNotificationBaseline(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALAssessmentNotificationBaseline/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetDropoutStudentReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetDropoutStudentReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetNewEntryStudentRpt(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetNewEntryStudentRpt/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolAssessmentLevelSchool(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolAssessmentLevelSchool/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMyESchoolAssessmentLevelStudent(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolAssessmentLevelStudent/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddExtraLectureAttendanceNB(schoolid, empid: string, standard: string, batchid: string, division: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddExtraLectureAttendanceNB/' + schoolid + '/' + empid + '/' + standard + '/' + batchid + '/' + division, data);
  }
  AddExtraLectureAttPending(schoolid: string, standard: string, batchid: string, division: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddExtraLectureAttPending/' + schoolid + '/' + standard + '/' + batchid + '/' + division, data);
  }

  GetRptAttendanceCenterWiseCAL2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCAL2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceCenterWiseCAL2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCAL2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCAL2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCAL2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCAL2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCAL2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCAL2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCAL2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCAL2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCAL2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCAL2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCAL2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCAL2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCAL2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptStudentEgradeAtt2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentEgradeAtt2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptStudentEgradeAtt2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentEgradeAtt2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCALSancharak2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCALSancharak2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCALSancharak2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCALSancharak2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCALSancharak2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCALSancharak2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCALSancharak2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCALSancharak2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCALSancharak2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCALSancharak2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCALSancharak2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCALSancharak2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseNB(month: string, year: string, userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseNB/' + month + '/' + year + '/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPlanTimeTableBatchNotification(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPlanTimeTableBatchNotification/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  MonthlyStudAttendanceDetailCal(schoolid: string, month: string, year: string, userid: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'MonthlyStudAttendanceDetailCal/' + schoolid + '/' + month + '/' + year + '/' + userid, data);
  }
  RptMyEschoolTeacherTrainingAttendance(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'RptMyEschoolTeacherTrainingAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMESTeacherTrainingAttendance(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESTeacherTrainingAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  InsertMyESchoolTeacherTrainingAttendance(schoolid: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertMyESchoolTeacherTrainingAttendance/' + schoolid + '/' + userid, data);
  }
  GetRptAserEnglishSchoolwise(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAserEnglishSchoolwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetStateWiseAllSummaryMyEschool(pgid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStateWiseAllSummaryMyEschool/' + pgid);
  }
  GetCityWiseAllSummaryMyEschool(userid: string, role: string, pgid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCityWiseAllSummaryMyEschool/' + userid + '/' + role + '/' + pgid);
  }
  GetMyEschoolTeacherList(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolTeacherList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSkillingWorkshopList(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSkillingWorkshopList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerWiseAllSummaryDash(userid: string, role: string, pgid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAllSummaryDash/' + userid + '/' + role + '/' + pgid);
  }
  GetMyEschoolTeacherTrainingAttendance(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolTeacherTrainingAttendance/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCityWiseAllSummaryEnglish(userid: string, role: string, pgid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCityWiseAllSummaryEnglish/' + userid + '/' + role + '/' + pgid);
  }
  GetCityWiseAllSummaryMindspark(userid: string, role: string, pgid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCityWiseAllSummaryMindspark/' + userid + '/' + role + '/' + pgid);
  }
  DownloadMyESchoolAserAssessment1to5(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMyESchoolAserAssessment1to5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMyESchoolAserAssessment6to8(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMyESchoolAserAssessment6to8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddMyESchoolAssessment1to5(schoolid: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMyESchoolAssessment1to5/' + schoolid + '/' + userid, data);
  }
  AddMyESchoolAssessment6to8(schoolid: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMyESchoolAssessment6to8/' + schoolid + '/' + userid, data);
  }
  GetMyEschoolTeacherTrainingFeedback(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolTeacherTrainingFeedback/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddMyEschoolTeacherTrainingFeedback(userid: string, data) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMyEschoolTeacherTrainingFeedback/' + userid, data);
  }
  GetRptMyEschoolTeacherTrainingFeedback(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolTeacherTrainingFeedback/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetLivelihoodPlacementReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetLivelihoodPlacementReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetLivelihoodAwarenessReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetLivelihoodAwarenessReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetLivelihoodAwarenessReportSummary(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetLivelihoodAwarenessReportSummary/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetLivelihoodCareerGuidanceReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetLivelihoodCareerGuidanceReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetLivelihoodjobportalregReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetLivelihoodjobportalregReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALTLWiseNBData(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALTLWiseNBData/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptDailyAttendanceTrackingSchool(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDailyAttendanceTrackingSchool/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolvisitList(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolvisitList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  InsertMyeschoolVisit(userid: string, data) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertMyeschoolVisit/' + userid, data);
  }
  UpdateMyEschoolVisit(myvid: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateMyEschoolVisit/' + myvid + '/' + userid, data);
  }
  GetMyEschoolVisit(id) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolVisit/' + id);
  }
  GetRptMyEschoolVisit(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolVisit/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolAssessmentLevelSchoolReport(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolAssessmentLevelSchoolReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolAssessmentLevelStudentReport(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolAssessmentLevelStudentReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyEschoolStudentwise1to5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolStudentwise1to5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyEschoolStudentwise6to8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolStudentwise6to8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd6(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd7(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd9(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd10(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALMidlinePracticalAssessment2023Gujaratstd11(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023Gujaratstd12(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023Gujaratstd12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023std5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023std6(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023std7(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023std8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023std9(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2023std10(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2023std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyStd5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyStd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyStd6(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyStd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyStd7(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyStd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyStd8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyStd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyStd9(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyStd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyStd10(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyStd10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALPracticalMidlinecompetencyGujarat(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALPracticalMidlinecompetencyGujarat/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadPracticalMidlineAssessmentCAL2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadPracticalMidlineAssessmentCAL2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline5std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline5std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline6std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline6std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline7std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline7std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline8std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline8std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline9std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline9std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline10std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline10std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline11std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline11std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline12std2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline12std2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline9stdGujarat2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline9stdGujarat2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline10stdGujarat2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline10stdGujarat2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline11stdGujarat2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline11stdGujarat2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline12stdGujarat2023(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline12stdGujarat2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMyESchoolAserAssessment1to8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMyESchoolAserAssessment1to8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetIDITimeTableDetailsList(ttmid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDITimeTableDetailsList/' + ttmid);
  }
  InsertIDIPlanTimeTableMaster(centid: string, createby: string, month: string, year: string, timetableid: string, pgid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIDIPlanTimeTableMaster/' + centid + '/' + createby + '/' + month + '/' + year + '/' + timetableid + '/' + pgid, data);
  }
  GetcenterwisePlanTTList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetcenterwisePlanTTList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetIDIPlanTimeTableDetails(ipmid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDIPlanTimeTableDetails/' + ipmid);
  }
  GetStudentAttedanceDetailListCALIDI(centid: string, month: string, year: string, batchid: string, day: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttedanceDetailListCALIDI/' + centid + '/' + month + '/' + year + '/' + batchid + '/' + day);
  }
  CheckStudentAttendanceIDI(centid: string, batch: string, month: string, year: string, day: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'CheckStudentAttendanceIDI/' + centid + '/' + batch + '/' + month + '/' + year + '/' + day);
  }
  AddActualStudentIDI(date: Date, parentbatch: string, batchid: string, createby: string, strday: string, pgid: string, ipdid: string, ipmid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddActualStudentIDI?date=' + date + '&parentbatch=' + parentbatch + '&batchid=' + batchid + '&createby=' + createby + '&strday=' + strday + '&pgid=' + pgid + '&ipdid=' + ipdid + '&ipmid=' + ipmid, data);
  }
  GetStudentAssignmentDetailListIDI(centid: string, batchid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAssignmentDetailListIDI/' + centid + '/' + batchid);
  }
  GetIDITimeTableMasterList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIDITimeTableMasterList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  InsertIDITimeTableMaster(centid: string, createby: string, academicyear: string, ttno: string, pgid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIDITimeTableMaster/' + centid + '/' + createby + '/' + academicyear + '/' + ttno + '/' + pgid, data);
  }
  GetTimeTableMasterDetailsIDI(ittmid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTimeTableMasterDetailsIDI/' + ittmid);
  }
  UpdateCenterwiseTimeTableDetail(ittmid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateCenterwiseTimeTableDetail?ittmid=' + ittmid + '&createby=' + createby, data);
  }
  AddNewCenterwiseTimeTableDetail(ittmid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddNewCenterwiseTimeTableDetail?ittmid=' + ittmid + '&createby=' + createby, data);
  }
  GetRptStudentWiseAttendanceIDI(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentWiseAttendanceIDI/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolTwentyPercentDataSchoolwise(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolTwentyPercentDataSchoolwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseEnglish2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseEnglish2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseEnglish2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseEnglish2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetGameKraftMCQEndlinecompetency2023Std9(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetGameKraftMCQEndlinecompetency2023Std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetGamekraftMCQEndlinecompetency2023Std10(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetGamekraftMCQEndlinecompetency2023Std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetGameKraftMCQEndlinecompetency2023Std11(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetGameKraftMCQEndlinecompetency2023Std11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetGameKraftMCQEndlinecompetency2023Std12(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetGameKraftMCQEndlinecompetency2023Std12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptDailyAttendanceTrackingSchoolWithDateFilter(userid: string, role: string, pgid: string, whr: string, filterWhr: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDailyAttendanceTrackingSchoolWithDateFilter/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, '') + '&' + 'filterWhr=' + btoa(filterWhr).replace(/=+$/, ''));
  }
  GetEnglishCompentancyStudentwiseMidlinelevelreport(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishCompentancyStudentwiseMidlinelevelreport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishMidlineAssessmentDetailstdWise(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishMidlineAssessmentDetailstdWise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishCompentancySchoolwiseMidlinelevel1report(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishCompentancySchoolwiseMidlinelevel1report/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseIDI2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseIDI2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadBaselineAssessmentFoundation(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadBaselineAssessmentFoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadPracticalBaselineAssessmentFoundation(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadPracticalBaselineAssessmentFoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  InsertSkillingWorkshop(createdby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertSkillingWorkshop/' + createdby, data);
  }
  GetFoundationBaselinePractical2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetFoundationBaselinePractical2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetFoundationMCQBaseline2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetFoundationMCQBaseline2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyESchoolInfraDetailCount(schoolid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyESchoolInfraDetailCount/' + schoolid);
  }
  GetRptComputerAssessment(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptComputerAssessment/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolcenterinfralist(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolcenterinfralist/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  InsertActionPointerMyESchool(userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertActionPointerMyESchool/' + userid, data);
  }

  GetActionPointerMyESchool(myvid: any) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetActionPointerMyESchool/' + myvid);
  }

  UpdateActionPointerMyEschool(myvid: any, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateActionPointerMyEschool/' + myvid + '/' + userid, data);
  }

  GetCALEndlinePracticalAssessment2023Gujaratstd5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd11(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023Gujaratstd12(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023Gujaratstd12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023std5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023std6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023std7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023std8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023std9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2023std10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2023std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetRptCALAssessmentLevelStudentPracticalEndline2023(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelStudentPracticalEndline2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALMCQEndlinecompetency2023Std5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std11(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALMCQEndlinecompetency2023Std12(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMCQEndlinecompetency2023Std12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetMyEschoolMasterTTReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolMasterTTReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  CenterInfraReport(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'CenterInfraReport/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAserComparison23(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAserComparison23/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishAserLevelBaselineMidlineComparision2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishAserLevelBaselineMidlineComparision2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishAserLevelBaselineEndlineComparision2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishAserLevelBaselineEndlineComparision2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishAserLevelBaselineMidlineComparisionStudentwise2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishAserLevelBaselineMidlineComparisionStudentwise2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishAserLevelBaselineEndlineComparisionStudentwise2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishAserLevelBaselineEndlineComparisionStudentwise2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAserBaselineMidlineComparision2023(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAserBaselineMidlineComparision2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSchoolTeacherTrainingAttendenceList2023(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolTeacherTrainingAttendenceList2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetFoundationPracticalBaselinecompetencyStd5to12(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetFoundationPracticalBaselinecompetencyStd5to12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALSchoolGradeWiseAssessmentfoundation(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALSchoolGradeWiseAssessmentfoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptStudentIdiLite(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentIdiLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerCenterGenderEnrollmentSummary(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerCenterGenderEnrollmentSummary?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetUpdateSchoolTeacherTrainingAttendences2023(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUpdateSchoolTeacherTrainingAttendences2023?whr=' + btoa(where).replace(/=+$/, ''))
  }
  AddExtraLectureAttendanceSE(schoolid, empid: string, standard: string, batchid: string, division: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddExtraLectureAttendanceSE/' + schoolid + '/' + empid + '/' + standard + '/' + batchid + '/' + division, data);
  }
  GetStudentAttendanceAlertSEDetails2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertSEDetails2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  AddExtraLectureAttSEPending(schoolid: string, standard: string, batchid: string, division: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddExtraLectureAttSEPending/' + schoolid + '/' + standard + '/' + batchid + '/' + division, data);
  }
  GetStudentAttendanceAlertSE2022English(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertSE2022English/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendanceAlertSE2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertSE2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendanceAlertPendingSE2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertPendingSE2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendanceAlertPendingSEEnglesh2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertPendingSEEnglesh2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  AddExtraLectureAttendanceH(schoolid, empid: string, standard: string, batchid: string, division: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddExtraLectureAttendanceH/' + schoolid + '/' + empid + '/' + standard + '/' + batchid + '/' + division, data);
  }
  GetStudentAttendanceAlertHDetails2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertHDetails2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  AddExtraLectureAttHPending(schoolid: string, standard: string, batchid: string, division: string, data: any): any {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddExtraLectureAttHPending/' + schoolid + '/' + standard + '/' + batchid + '/' + division, data);
  }
  GetStudentAttendanceAlertH2022English(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertH2022English/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendanceAlertH2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertH2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendanceAlertPendingH2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertPendingH2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetStudentAttendanceAlertPendingHEnglesh2022(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceAlertPendingHEnglesh2022/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAssessmentPartnerWiseCountAser(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAssessmentPartnerWiseCountAser/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAssessmentPartnerWiseCountTheory(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAssessmentPartnerWiseCountTheory/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAssessmentPartnerWiseCountPractical(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAssessmentPartnerWiseCountPractical/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAssessmentPartnerWiseCountKerala(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAssessmentPartnerWiseCountKerala/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptCALAssessmentLevelSchool2022Practical2022Kerala(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelSchool2022Practical2022Kerala/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptCALAssessmentLevelStudentPracticalBaseline2023Kerala(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelStudentPracticalBaseline2023Kerala/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptCareerAwarenessCAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCareerAwarenessCAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadEndlineAssessmentFoundation(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadEndlineAssessmentFoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadPracticalEndlineAssessmentFoundation(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadPracticalEndlineAssessmentFoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSchoolTeacherTrainingList2023English(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolTeacherTrainingList2023English/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  InsertSchoolTeacherTraining2023English(data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertSchoolTeacherTraining2023English/', data);
  }

  SchoolTeacherTrainingDetails2023English(schteachtranid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'SchoolTeacherTrainingDetails2023English/' + schteachtranid);
  }

  DownloadschoolteachertrainingAtt2023English(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadschoolteachertrainingAtt2023English?whr=' + btoa(where).replace(/=+$/, ''))
  }
  DownloadSchoolTeacherTrainingTest2023English(schteachtranid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadSchoolTeacherTrainingTest2023English/' + schteachtranid)
  }
  DownloadSchoolTeacherTrainingPostTest2023English(schteachtranid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadSchoolTeacherTrainingPostTest2023English/' + schteachtranid)
  }
  GetUpdateSchoolTeacherTrainingAttendences2023English(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUpdateSchoolTeacherTrainingAttendences2023English?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetUpdateSchoolTeacherTrainingFeedback2023English(schteachtranid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUpdateSchoolTeacherTrainingFeedback2023English/' + schteachtranid)
  }
  GetUpdateSchoolTeacherTrainingTest2023English(schteachtranid: string, type: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUpdateSchoolTeacherTrainingTest2023English/' + schteachtranid + '/' + type);
  }
  GetTeacherTrainingsPicEnglish(id: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetTeacherTrainingsPicEnglish/' + id);
  }
  AddSchoolTeacherTrainingsPhotoEnglish(schteachtranid: string, userid: string, fileToUpload: File) {
    const formData: FormData = new FormData();
    formData.append('Image', fileToUpload);
    return this.http.post(environment.apiUrl + 'Student/' + 'AddSchoolTeacherTrainingsPhotoEnglish/' + schteachtranid + '/' + userid, formData);
  }

  RemoveTeacherTrainingsPhotoEnglish(id: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'RemoveTeacherTrainingsPhotoEnglish/' + id);
  }
  UpdateSchoolTeacherTrainingAttendence2023English(createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateSchoolTeacherTrainingAttendence2023English/' + createby, data);
  }

  UpdateSchoolTeacherTrainingTest2023English(createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateSchoolTeacherTrainingTest2023English/' + createby, data);
  }

  UpdateSchoolTeacherTrainingFeedback2023English(createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateSchoolTeacherTrainingFeedback2023English/' + createby, data);
  }
  GetRptSchoolTeacherSummaryTraining2023English(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSchoolTeacherSummaryTraining2023English/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSchoolTeacherTrainingAttendenceList2023English(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolTeacherTrainingAttendenceList2023English/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetUpdateSchoolTeacherTrainingTest2023(schteachtranid: string, type: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetUpdateSchoolTeacherTrainingTest2023/' + schteachtranid + '/' + type);
  }
  GetRptSchoolTeacherTrainingDetail2023English(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSchoolTeacherTrainingDetail2023English/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetStatewiseEnrollmentLite(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStatewiseEnrollmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCitywiseEnrollmentLite(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCitywiseEnrollmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSchoolwiseEnrollmentLite(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolwiseEnrollmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetGenderwiseEnrollmentLite(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetGenderwiseEnrollmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptComputerHardwareIDI(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptComputerHardwareIDI/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptComplaintMES(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptComplaintMES/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerwiseComparisionBaselineEndline2023(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseComparisionBaselineEndline2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerwiseComparisionBaselineEndlineSubir2023(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseComparisionBaselineEndlineSubir2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPartnerWiseAserComparison23(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAserComparison23/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPartnerWiseAserComparison24(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAserComparison24/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPartnerWiseAserComparisonBaselineEndline23(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAserComparisonBaselineEndline23/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPartnerwiseComparisionBaselineMidline2023(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseComparisionBaselineMidline2023/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPartnerwiseComparisionBaselineMidline2024(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseComparisionBaselineMidline2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPartnerwiseBaselineEndlineComparision2023KeralaSem1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseBaselineEndlineComparision2023KeralaSem1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetStudentWiseBaselineEndlineComparisionFoundation(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentWiseBaselineEndlineComparisionFoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetSchoolWiseBaselineEndlineComparisionFoundation(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetSchoolWiseBaselineEndlineComparisionFoundation/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolBaselineEndlineSchoolWiseComparision(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolBaselineEndlineSchoolWiseComparision/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolMidlineEndlineStudentWiseComparision(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolMidlineEndlineStudentWiseComparision/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolMidlineEndlineSchoolWiseComparision(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolMidlineEndlineSchoolWiseComparision/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetMyEschoolBaselineEndlineStudentWiseComparision(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolBaselineEndlineStudentWiseComparision/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishComperisionStd5to11Level1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishComperisionStd5to11Level1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishComperisionStd5to11Level2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishComperisionStd5to11Level2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishStudentWiseBaselineEndlineComperisionLevel1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishStudentWiseBaselineEndlineComperisionLevel1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishStudentWiseBaselineEndlineComperisionLevel2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishStudentWiseBaselineEndlineComperisionLevel2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishBaselineMidlineComperisionStd5to11Level1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishBaselineMidlineComperisionStd5to11Level1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishBaselineMidlineComperisionStd5to11Level2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishBaselineMidlineComperisionStd5to11Level2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishStudentWiseBaselineMidlineComperisionLevel1(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishStudentWiseBaselineMidlineComperisionLevel1/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetEnglishStudentWiseBaselineMidlineComperisionLevel2(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetEnglishStudentWiseBaselineMidlineComperisionLevel2/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAserStudentwise2024(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAserStudentwise2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessmentLevelStudentTheory2024(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelStudentTheory2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  MyeschoolAserBonus2024(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'MyeschoolAserBonus2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALBaselinePracticalAssessment2024std5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024Gujaratstd5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024std6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }


  GetCALBaselinePracticalAssessment2024Gujaratstd6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2024std7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }


  GetCALBaselinePracticalAssessment2024Gujaratstd7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024std8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024Gujaratstd8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024std9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024Gujaratstd9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2024std10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetCALBaselinePracticalAssessment2024Gujaratstd10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2024Gujaratstd11(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2024Gujaratstd12(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2024Gujaratstd12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }

  GetRptCALAssessmentLevelStudentPracticalBaseline2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelStudentPracticalBaseline2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessmentLevelStudentTheoryEndline2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelStudentTheoryEndline2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessment2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessment2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALGradewiseAssessmentMCQBaseline5std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline5std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline6std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline6std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline7std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline7std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline8std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline8std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline9std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline9std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline10std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline10std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline11std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline11std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline12std2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline12std2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline9stdGujarat2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline9stdGujarat2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline10stdGujarat2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline10stdGujarat2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline11stdGujarat2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline11stdGujarat2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline12stdGujarat2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline12stdGujarat2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline5std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline5std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline6std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline6std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline7std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline7std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline8std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline8std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline9std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline9std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline10std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline10std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline11std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline11std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline12std2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline12std2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline9stdGujarat2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline9stdGujarat2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline10stdGujarat2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline10stdGujarat2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline11stdGujarat2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline11stdGujarat2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQBaseline12stdGujarat2025(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQBaseline12stdGujarat2025/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolStudentwiseSTEM24(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolStudentwiseSTEM24/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolschoolwiseSTEM24(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolschoolwiseSTEM24/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMyESchoolAserAssessment1to8ITC(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMyESchoolAserAssessment1to8ITC/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddMESAssessmentITC(schoolid: string, userid: string, examtype: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMESAssessmentITC/' + schoolid + '/' + userid + '/' + examtype, data);
  }

  GetStudentLiteMESList(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentLiteMESList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  InsertStudentLiteMES(data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertStudentLiteMES', data);
  }
  GetStudentLiteMESDetail(studentid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentLiteMESDetail/' + studentid);
  }
  UpdateStudentLiteMES(studentid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateStudentLiteMES/' + studentid, data);
  }
  GetRptStudentLiteMyschool(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentLiteMyschool/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  UpdateUploadStudentLiteMES(schoolid: string, createby: string, data: any) {
    return this.http.post<ApiResponse>(environment.apiUrl + 'Student/' + 'UpdateUploadStudentLiteMES/' + schoolid + '/' + createby, data);
  }

  GetRptMasterTimeTableSummary(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMasterTimeTableSummary/' + userid + '/' + role + '/' + pgid + '/' + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadBaselineAssessmentSubirMCQ(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadBaselineAssessmentSubirMCQ/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  AddDLLSSubirAssessmentBaseline2024(empid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddDLLSSubirAssessmentBaseline2024/' + empid, data);
  }
  GetRptIDIEvalautionEmployabilitySpoke(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIEvalautionEmployabilitySpoke/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPlannedMonthlySchoolMES(month: string, year: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPlannedMonthlySchoolMES/' + month + '/' + year + '/' + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  AddPlannedMonthlyCenterVisitMES(empid: string, data) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddPlannedMonthlyCenterVisitMES/' + empid, data);
  }

  GetRptMonthlySchoolVisitSummaryMES(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMonthlySchoolVisitSummaryMES/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerWiseAllSummaryDashCEO(userid: string, role: string, pgid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAllSummaryDashCEO/' + userid + '/' + role + '/' + pgid);
  }
  GetRptMyESchoolStudentwiseSTEM24Lite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolStudentwiseSTEM24Lite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyESchoolschoolwiseSTEM24Lite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyESchoolschoolwiseSTEM24Lite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddMESAssessmentSTEM(schoolid: string, userid: string, examtype: string, mode: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMESAssessmentSTEM/' + schoolid + '/' + userid + '/' + examtype + '/' + mode, data);
  }
  DownloadMyESchoolSTEMImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMyESchoolSTEMImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMyESchoolSTEMLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMyESchoolSTEMLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMESLiteracyAssessmentImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESLiteracyAssessmentImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMESLiteracyAssessmentLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESLiteracyAssessmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  AddMESLiteracyAssessment(schoolid: string, userid: string, examtype: string, mode: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMESLiteracyAssessment/' + schoolid + '/' + userid + '/' + examtype + '/' + mode, data);
  }

  DownloadMESNumeracyAssessmentImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESNumeracyAssessmentImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadMESNumeracyAssessmentLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESNumeracyAssessmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  AddMESNumeracyAssessment(schoolid: string, userid: string, examtype: string, mode: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddMESNumeracyAssessment/' + schoolid + '/' + userid + '/' + examtype + '/' + mode, data);
  }
  InsertCenterInfraMyEschoolLite(centid: string, userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertCenterInfraMyEschoolLite/' + centid + '/' + userid, data);
  }
  GetCenterInfraMyEschoolLite(centid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCenterInfraMyEschoolLite/' + centid);
  }
  DownloadMESCenterInfraLite(centid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESCenterInfraLite/' + centid);
  }
  GetRptMESLiteracyAssessmentStudentwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentStudentwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESNumeracyAssessmentStudentwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumeracyAssessmentStudentwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESLiteracyAssessmentStudentwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentStudentwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESNumeracyAssessmentStudentwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumeracyAssessmentStudentwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESLiteracyAssessmentSchoolwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentSchoolwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESNumeracyAssessmentSchoolwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumeracyAssessmentSchoolwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESLiteracyAssessmentSchoolwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentSchoolwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESNumeracyAssessmentSchoolwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumeracyAssessmentSchoolwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetStudentSearchList(whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentSearchList?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptTransferStudentDetails2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptTransferStudentDetails2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptTransferStudentSchoolwise(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptTransferStudentSchoolwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMESTeacherAppData(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESTeacherAppData/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetMyEschoolvisitListLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolvisitListLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptMyEschoolVisitLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolVisitLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadIVDPLiteracyAssessmentLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadIVDPLiteracyAssessmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadIVDPLiteracyAssessmentImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadIVDPLiteracyAssessmentImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadIVDPNumeracyAssessmentLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadIVDPNumeracyAssessmentLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadIVDPNumeracyAssessmentImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadIVDPNumeracyAssessmentImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  AddIVDPNumeracyAssessment(schoolid: string, userid: string, examtype: string, mode: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddIVDPNumeracyAssessment/' + schoolid + '/' + userid + '/' + examtype + '/' + mode, data);
  }

  AddIVDPLiteracyAssessment(schoolid: string, userid: string, examtype: string, mode: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddIVDPLiteracyAssessment/' + schoolid + '/' + userid + '/' + examtype + '/' + mode, data);
  }

  GetRptIVDPLiteracyAssessmentSchoolwiseImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyAssessmentSchoolwiseImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPLiteracyAssessmentSchoolwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyAssessmentSchoolwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPLiteracyAssessmentStudentwiseImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyAssessmentStudentwiseImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPLiteracyAssessmentStudentwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyAssessmentStudentwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPNumeracyAssessmentSchoolwiseImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyAssessmentSchoolwiseImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPNumeracyAssessmentSchoolwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyAssessmentSchoolwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPNumeracyAssessmentStudentwiseImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyAssessmentStudentwiseImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIVDPNumeracyAssessmentStudentwiselite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyAssessmentStudentwiselite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownlodeTeacherWorkshopfeedback2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownlodeTeacherWorkshopfeedback2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  AddTeacherTrainingFeedback2024(userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddTeacherTrainingFeedback2024/' + userid, data);
  }

  GetRptTeacherTrainingFeedbackCAL(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptTeacherTrainingFeedbackCAL/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptTeacherTrainingFeedbackDLLS(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptTeacherTrainingFeedbackDLLS/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPlannedMonthlySchoolMESLite(month: string, year: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPlannedMonthlySchoolMESLite/' + month + '/' + year + '/' + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetMyEschoolTimeTableList2024(schoolid: string, giditalclassroomno: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetMyEschoolTimeTableList2024/' + schoolid + '/' + giditalclassroomno);
  }

  GetCALMidlinePracticalAssessment2024std5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024std6(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024std7(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024std8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024std9(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024std10(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALMidlinePracticalAssessment2024Gujaratstd5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024Gujaratstd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024Gujaratstd6(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024Gujaratstd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024Gujaratstd7(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024Gujaratstd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024Gujaratstd8(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024Gujaratstd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCALGradewiseAssessmentMCQMidline5std2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline5std2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline6std2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline6std2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline7std2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline7std2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline8std2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline8std2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline9std2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline9std2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline11std2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline11std2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline9stdGujarat2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline9stdGujarat2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALGradewiseAssessmentMCQMidline11stdGujarat2024(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALGradewiseAssessmentMCQMidline11stdGujarat2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024Gujaratstd9(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024Gujaratstd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALMidlinePracticalAssessment2024Gujaratstd11(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALMidlinePracticalAssessment2024Gujaratstd11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  InsertIVDPTeacher(userid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIVDPTeacher/' + userid, data);
  }

  GetIVDPTeacher(itechid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIVDPTeacher/' + itechid);
  }

  GetIVDPTeacherList(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIVDPTeacherList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  UpdateIVDPTeacher(itechid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateIVDPTeacher/' + itechid, data);
  }

  GetIVDPTeacherTraning(whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetIVDPTeacherTraning?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  InsertIVDPTeacherTraining(itechid: string, userId: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertIVDPTeacherTraining/' + itechid + '/' + userId, data);
  }

  UpdateIVDPTeacherTraining(itechid: string, userId: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateIVDPTeacherTraining/' + itechid + '/' + userId, data);
  }

  GetRptIVDPTeacherTraining(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPTeacherTraining/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetAsetBaselineMidlineComparisionCity2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAsetBaselineMidlineComparisionCity2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPracticalTheoryBaselineMidlineComparisionCity2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineMidlineComparisionCity2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAsetBaselineEndlineNewComparisionCity2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAsetBaselineEndlineNewComparisionCity2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPracticalTheoryBaselineEndlineComparisionCity2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineEndlineComparisionCity2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAsetBaselineMidlineComparisionPartner2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAsetBaselineMidlineComparisionPartner2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPracticalTheoryBaselineMidlineComparisionjankari2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineMidlineComparisionjankari2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAsetBaselineEndlineNewComparisionPartner2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAsetBaselineEndlineNewComparisionPartner2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPracticalTheoryBaselineEndlineComparisionjankari2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineEndlineComparisionjankari2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAserBaselineMidlineComparisionState2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAserBaselineMidlineComparisionState2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetAserBaselineEndlineNewComparisionState2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAserBaselineEndlineNewComparisionState2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPracticalTheoryBaselineMidlineComparisionState2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineMidlineComparisionState2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPracticalTheoryBaselineEndlineComparisionState2024(Userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineEndlineComparisionState2024/' + Userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptIDIEvalautionEmployabilityIBMNew(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIEvalautionEmployabilityIBMNew/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetAserBaselineMidlineComparision2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAserBaselineMidlineComparision2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetAserComparison24(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAserComparison24/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadMESLiteracyAssessmentImpact3to5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESLiteracyAssessmentImpact3to5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadMESLiteracyAssessmentLite3to5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESLiteracyAssessmentLite3to5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadMESNumeracyAssessmentImpact3to5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESNumeracyAssessmentImpact3to5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  DownloadMESNumeracyAssessmentLite3to5(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadMESNumeracyAssessmentLite3to5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetITCTeacherTraning(whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetITCTeacherTraning?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  InsertITCTeacherTraining(itechid: string, userId: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'InsertITCTeacherTraining/' + itechid + '/' + userId, data);
  }

  UpdateITCTeacherTraining(itechid: string, userId: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateITCTeacherTraining/' + itechid + '/' + userId, data);
  }

  GetRptMyEschoolTeacherTrainingMarathi(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolTeacherTrainingMarathi/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetRptMyEschoolTeacherTrainingHindi(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyEschoolTeacherTrainingHindi/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  AddDLLSSubirAssessmentMidline2024(empid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddDLLSSubirAssessmentMidline2024/' + empid, data);
  }

  GetRptCenterMyESchool(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCenterMyESchool/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetRptSchoolMyESchool(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSchoolMyESchool/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetCAlSchoolMonthWiseAttendanceGraph(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCAlSchoolMonthWiseAttendanceGraph/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetRptMyeschoolTimeTableSummary(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyeschoolTimeTableSummary/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyeschoolTimeTableDetailedSummary(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyeschoolTimeTableDetailedSummary/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyeschoolTimeTableSummaryLite(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyeschoolTimeTableSummaryLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMyeschoolTimeTableDetailedSummaryLite(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMyeschoolTimeTableDetailedSummaryLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }

  GetPracticalTheoryBaselineMidlineComparisionStudent2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineMidlineComparisionStudent2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPracticalTheoryBaselineMidlineComparision2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineMidlineComparision2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptDSAVideoMonthlyUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoMonthlyUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoMonthlyUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoMonthlyUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoSubjectwiseUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoSubjectwiseUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoSubjectwiseUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoSubjectwiseUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoStandardwiseUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoStandardwiseUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoStandardwiseUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoStandardwiseUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoPartnerwiseUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoPartnerwiseUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoPartnerwiseUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoPartnerwiseUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetCenterInfraMyESchoolListImpactAndLite(userid: string, role: string, pgid: string, mode: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCenterInfraMyESchoolListImpactAndLite/' + userid + '/' + role + '/' + pgid + '/' + mode + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetDSAAppSchoolwiseSummaryImpact(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetDSAAppSchoolwiseSummaryImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetDSAAppSchoolwiseSummaryLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetDSAAppSchoolwiseSummaryLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetDSAAppSchoolwiseDetailImpact(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetDSAAppSchoolwiseDetailImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetDSAAppSchoolwiseDetailLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetDSAAppSchoolwiseDetailLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetAssociateOHPartnerWiseAllSummaryDash(userid: string, role: string, pgid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAssociateOHPartnerWiseAllSummaryDash/' + userid + '/' + role + '/' + pgid);
  }
  GetRptDSAVideoAllMonthlyUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllMonthlyUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllMonthlyUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllMonthlyUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllSubjectwiseUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllSubjectwiseUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllSubjectwiseUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllSubjectwiseUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllStandardwiseUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllStandardwiseUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllStandardwiseUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllStandardwiseUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllPartnerwiseUsage(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllPartnerwiseUsage/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptDSAVideoAllPartnerwiseUsageLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptDSAVideoAllPartnerwiseUsageLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetCALEndlinePracticalAssessment2024std5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024std6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024std7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024std8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024std9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Std10to12(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Std10to12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }


  GetCALEndlinePracticalAssessment2024Gujaratstd5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd11(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALEndlinePracticalAssessment2024Gujaratstd12(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALEndlinePracticalAssessment2024Gujaratstd12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetRptMESTeacherAppDataLite(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESTeacherAppDataLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  AddDLLSSubirAssessmentEndline2024(empid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddDLLSSubirAssessmentEndline2024/' + empid, data);
  }
  AddStudentAttendanceIVDP(empid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddStudentAttendanceIVDP/' + empid, data);
  }
  GetStudentAttendanceIVDPAttList(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttendanceIVDPAttList/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetStudentAssignmentDetailListIVDP(userid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAssignmentDetailListIVDP/' + userid);
  }
  AddStudAttendanceDetailIVDP(date: Date, createby: string, strday: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddStudAttendanceDetailIVDP?date=' + date + '&createby=' + createby + '&strday=' + strday, data);
  }
  CheckStudentAttendanceIVDP(schoolid: string, month: string, year: string, day: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'CheckStudentAttendanceIVDP/' + schoolid + '/' + month + '/' + year + '/' + day);
  }
  GetStudentAttedanceDetailListIVDP(schoolid: string, month: string, year: string, day: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStudentAttedanceDetailListIVDP/' + schoolid + '/' + month + '/' + year + '/' + day);
  }
  IVDPAttCheckMonthWise(schoolid: string, month: string, year: StringMapWithRename): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'IVDPAttCheckMonthWise/' + schoolid + '/' + month + '/' + year);
  }
  GetRptAttendanceGradewiseIVDP(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseIVDP/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseIVDPDetail(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseIVDPDetail/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseIVDP(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseIVDP/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptStudentEgradeAttIVDP(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentEgradeAttIVDP/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseIVDP(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseIVDP/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseIVDPDetailabsent(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseIVDPDetailabsent/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerWiseAllSummaryDashHR(userid: string, role: string, pgid: string) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAllSummaryDashHR/' + userid + '/' + role + '/' + pgid);
  }
  GetStateWiseAllSummaryHR(pgid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetStateWiseAllSummaryHR/' + pgid);
  }
  GetCityWiseAllSummaryHR(pgid: string): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCityWiseAllSummaryHR/' + pgid);
  }
  DownloadIVDPLiteracyAssessmentEndlineImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadIVDPLiteracyAssessmentEndlineImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  DownloadIVDPNumeracyAssessmentEndlineImpact(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'DownloadIVDPNumeracyAssessmentEndlineImpact/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetGradewiseAssessmentAI(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetGradewiseAssessmentAI/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptMESLiteracyAssessmentSchoolWiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentSchoolWiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESLiteracyAssessmentSchoolWiseCompairsionLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentSchoolWiseCompairsionLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESNumaracyAssessmentSchoolWiseCompairsionLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumaracyAssessmentSchoolWiseCompairsionLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESNumaracyAssessmentSchoolWiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumaracyAssessmentSchoolWiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESNumeracyAssessmentStudentwiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumeracyAssessmentStudentwiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESNumeracyAssessmentStudentwiseCompairsionLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumeracyAssessmentStudentwiseCompairsionLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESLiteracyAssessmentStudentwiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentStudentwiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESLiteracyAssessmentStudentwiseCompairsionLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyAssessmentStudentwiseCompairsionLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptSTEMAssessmentStudentwiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSTEMAssessmentStudentwiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptSTEMAssessmentStudentwiseCompairsionLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSTEMAssessmentStudentwiseCompairsionLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetAssessmentAINonpifReport(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetAssessmentAINonpifReport/' + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptIVDPNumeracyAssessmentSchoolWiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyAssessmentSchoolWiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPLiteracyAssessmentSchoolWiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyAssessmentSchoolWiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPNumeracyAssessmentStudentwiseImpactCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyAssessmentStudentwiseImpactCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPLiteracyAssessmentStudentwiseImpactCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyAssessmentStudentwiseImpactCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptSTEMAssessmentSchoolwiseCompairsion(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSTEMAssessmentSchoolwiseCompairsion/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptSTEMAssessmentSchoolwiseCompairsionLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSTEMAssessmentSchoolwiseCompairsionLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetNonPIFStudentAssessmentNotification(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetNonPIFStudentAssessmentNotification/' + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetPartnerwiseComparisionBaselineEndline2024(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseComparisionBaselineEndline2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerWiseAserComparisonBaselineEndline24(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerWiseAserComparisonBaselineEndline24/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAIAppData(where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAIAppData/' + '?whr=' + btoa(where).replace(/=+$/, ''));
  }

  GetPracticalTheoryBaselineEndlineComparision2024Kerala(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineEndlineComparision2024Kerala/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPracticalTheoryBaselineEndlineComparisionStudent2024Kerala(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPracticalTheoryBaselineEndlineComparisionStudent2024Kerala/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetCALBaselinePracticalAssessment2025std5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025std5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd5(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd5/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025std6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025std6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd6(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd6/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025std7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025std7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd7(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd7/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025std8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025std8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd8(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd8/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025std9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025std9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025std10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025std10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd9(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd9/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd10(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd10/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd11(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd11/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  GetCALBaselinePracticalAssessment2025Gujaratstd12(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetCALBaselinePracticalAssessment2025Gujaratstd12/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''))
  }
  AddDLLSSubirAssessmentBaseline2025(empid: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'AddDLLSSubirAssessmentBaseline2025/' + empid, data);
  }
  GetNewEntryStudentRptMES(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetNewEntryStudentRptMES/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetNewEntryStudentRptMESLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetNewEntryStudentRptMESLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetdroupoutstudentRptMES(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetdroupoutstudentRptMES/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetdroupoutstudentRptMESLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetdroupoutstudentRptMESLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  UpdateUploadStudentIdiLiteInstitutional(collegeid: string, createby: string, data: any) {
    return this.http.post(environment.apiUrl + 'Student/' + 'UpdateUploadStudentIdiLiteInstitutional/' + collegeid + '/' + createby, data);
  }
  GetRptInstitutionalStudentIdiLite(userid: string, role: string, pgid: string, where): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptInstitutionalStudentIdiLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
  GetRptAttendanceCenterWiseCAL2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceCenterWiseCAL2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCALSancharak2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCALSancharak2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceSchoolWiseCAL2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceSchoolWiseCAL2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCALSancharak2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCALSancharak2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceGradewiseCAL2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceGradewiseCAL2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCALSancharak2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCALSancharak2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptAttendanceStudWiseCAL2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptAttendanceStudWiseCAL2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptStudentEgradeAtt2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptStudentEgradeAtt2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESLiteracyCompairsionPartnerWise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyCompairsionPartnerWise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESLiteracyCompairsionPartnerWiseLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESLiteracyCompairsionPartnerWiseLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESNumaracyCompairsionPartnerWise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumaracyCompairsionPartnerWise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptMESNumaracyCompairsionPartnerWiseLite(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptMESNumaracyCompairsionPartnerWiseLite/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPLiteracyCompairsionPartnerwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracyCompairsionPartnerwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPLiteracylitePartnerwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPLiteracylitePartnerwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPNumeracyCompairsionPartnerWise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracyCompairsionPartnerWise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIVDPNumeracylitePartnerWise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIVDPNumeracylitePartnerWise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptSTEMCompairsionPartnerwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSTEMCompairsionPartnerwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptSTEMCompairsionLitepartnerwise(userid: string, role: string, pgid, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptSTEMCompairsionLitepartnerwise/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetPartnerwiseComparisionBaselineEndlineKerala2024(userid: string, role: string, pgid: string, whr) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetPartnerwiseComparisionBaselineEndlineKerala2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIDIStudentAttendance2024(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIStudentAttendance2024/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptIDIStudentAttendance2025(userid: string, role: string, pgid: string, whr): any {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptIDIStudentAttendance2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(whr).replace(/=+$/, ''));
  }
  GetRptCALAssessmentLevelStudentTheory2025(userid: string, role: string, pgid: string, where) {
    return this.http.get(environment.apiUrl + 'Student/' + 'GetRptCALAssessmentLevelStudentTheory2025/' + userid + '/' + role + '/' + pgid + '?whr=' + btoa(where).replace(/=+$/, ''));
  }
}
